export const DICE_ROLL_KEY_CONCEPT_SEPARATOR = '__';
export const DICE_ROLL_KEY_DATA_SEPARATOR = '--';
export var DiceRollExcludeTypeEnum;
(function (DiceRollExcludeTypeEnum) {
    DiceRollExcludeTypeEnum[DiceRollExcludeTypeEnum["ALL"] = 1] = "ALL";
    DiceRollExcludeTypeEnum[DiceRollExcludeTypeEnum["NONE"] = 2] = "NONE";
})(DiceRollExcludeTypeEnum || (DiceRollExcludeTypeEnum = {}));
